import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA} from "@angular/material";

@Component({
    selector: "iinvest-confirmation-dialog",
    templateUrl: "./ConfirmationDialogComponent.html"
})
export class ConfirmationDialogComponent {

    public title: string;
    public message: string;

    public constructor(@Inject(MAT_DIALOG_DATA) data: ConfirmationDialogData) {
        this.title = data.title;
        this.message = data.message;
    }
}

export interface ConfirmationDialogData {
    title: string;
    message: string;
}
